import { combineReducers } from 'redux';
import baseApi from 'services/api/baseApi';

import azureEnvironment from './azureEnvironment.slice';
import notifications from './notifications.slice';
import resizerLayout from './resizer.slice';
import responsive from './responsive.slice';
import user from './user.slice';

export default combineReducers({
  user,
  azureEnvironment,
  resizerLayout,
  responsive,
  notifications,
  [baseApi.reducerPath]: baseApi.reducer,
});
